export default __webpack_public_path__ + "static/media/bt-1.ad4d446b.jpg";